const menuInit = () =>{
    const navbar = document.querySelector('header .navbar');
    const toggler = navbar.querySelector('.navbar-toggler');
    const theMenu = document.querySelector('.ume-intra-main-menu');
    const topHeader = document.querySelector('.ume-intra-top-menu-wrapper');
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    let last_known_scroll_position = 0;
    let ticking = false;
    window.addEventListener('scroll', function () {
        if (vw > 1180) {
            last_known_scroll_position = window.scrollY;
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    scrollEventThrottle(last_known_scroll_position);
                    ticking = false;
                });
                ticking = true;
            }
        }
    });
    const scrollEventThrottle = ((scrollPos) => {

        const brand = navbar.querySelector('.ume-intra-brand');
        const picEl = brand.querySelector('picture');
        const source    = picEl.querySelector('source');
        let old = source.getAttribute('data-old-source')
        if (scrollPos < 50) {
            if(source && old !== null){
                source.srcset = old;
            }
        } else {
            if(source && source.srcset !== ''){
                let theSrc = source.srcset;
                source.srcset = '';

                source.setAttribute('data-old-source', theSrc)
            }
        }
    });
    if(vw > 1180){
        if(theMenu !== null){
            theMenu.addEventListener('shown.bs.dropdown', ev => {
                if(ev.target.closest('.ume-intra-mega-menu')){
                    document.body.classList.add('menu-open');
                }

            });
            theMenu.addEventListener('hide.bs.dropdown', ev => {
                if(ev.target.closest('.ume-intra-mega-menu')) {
                    document.body.classList.remove('menu-open');
                }
            });
        }
    }


    if(toggler !== null && toggler !== undefined){
        toggler.addEventListener('click', ev => {
            navbar.setAttribute('data-hide-top', 'false');
            if (toggler.classList.contains('collapsed')) {
                let scrollTo = toggler.getAttribute('data-scroll-y');
                document.body.classList.remove('menu-open');
                window.scrollTo({top: scrollTo * 1, left: 0, behavior: "instant"});
                let activeSubSubMenus = navbar.querySelectorAll('.ume-intra-mega-menu-target-container-active');
                let activeExpanded = navbar.querySelectorAll('.ume-intra-mega-dropdown-toggle[aria-expanded="true"]');
                if(activeSubSubMenus.length > 0){
                    activeSubSubMenus.forEach(sub => {
                        sub.classList.remove('ume-intra-mega-menu-target-container-active');
                        sub.innerHTML = '';
                    })
                }
                if(activeExpanded.length > 0){
                    activeExpanded.forEach(exp =>{
                        exp.setAttribute('aria-expanded', 'false');
                    })
                }

            } else {
                toggler.setAttribute('data-scroll-y', window.scrollY.toString());
                document.body.classList.add('menu-open');
                if(typeof topHeader !== 'undefined' && topHeader !== null){
                    let topHeaderHeight = topHeader.offsetHeight;
                    document.documentElement.style.setProperty('--top-header-height', topHeaderHeight + 'px');

                }

                // make sure top of menu is visible on smaller mobile screens that require menu scrolling (column-reverse issue)
                setTimeout(() => {
                    theMenu.scrollTop = -theMenu.scrollHeight;
                }, 500)

            }
        })
    }

}
export default menuInit;